import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class Button extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    if(this.props.disabled) {
      e.preventDefault();
    }
    const { onClick } = this.props;
    if(onClick) {
      onClick();
    }
  }

  render() {
    const { children, icon, preIcon, type, alt, disabled, className, showLoader } = this.props;
    let classStr = '';
    if(disabled) {
      classStr = 'disabled';
    } else if(alt) {
      classStr = 'alt';
    }
    return (
      <button
        type={type}
        disabled={disabled}
        onClick={this.handleClick}
        className={`fe-u-btn ${classStr} ${className ? className : ''}`}
      >
        {preIcon && <img src={preIcon} alt=""/>}
        <span>{children}</span>
        {icon && <img src={icon} alt=""/>}
        {showLoader && disabled ?
          <div className="lds-dual-ring-mini">
            <div></div><div></div><div></div><div></div>
          </div> : null}
      </button>
    );
  }
}

Button.propTypes = {
  children: PropTypes.string.isRequired,
  icon: PropTypes.string,
  preIcon: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  alt: PropTypes.bool.isRequired,
  className: PropTypes.string,
  showLoader: PropTypes.bool.isRequired,
};

Button.defaultProps = {
  type: 'button',
  disabled: false,
  alt: false,
  showLoader: true,
};